import React from 'react';
import CampoBuscarClub from '../../UI/campos/CampoBuscarClub.js';
import CampoEditableFechaCampos from '../../UI/campos/CampoEditableFechaCampos.js';
import * as Campos from '../../constantes/Campos.js';
import styles from '../EditarItemLista.module.css';

const CamposEstadioClub = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;
  const pais = props.pais;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Club</td>
        <td className={`${styles.valor}`}>
          <CampoBuscarClub
            nombre={Campos.ClubEstadio.CLUB}
            valor={item.club}
            editar={editar}
            width="80%"
            actualizar={actualizar}
            pais={pais}
            onClubElegido={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Desde</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.ClubEstadio.FECHA_DESDE}
            anio={item && item.anioDesde}
            mes={item && item.mesDesde}
            dia={item && item.diaDesde}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Hasta</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.ClubEstadio.FECHA_HASTA}
            anio={item && item.anioHasta}
            mes={item && item.mesHasta}
            dia={item && item.diaHasta}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposEstadioClub;
